import { Column } from "components/flexComponents/MultiColumnContainer/model/Column";
import { TwoColumn } from "components/flexComponents/MultiColumnContainer/decorators/TwoColumn/TwoColumn";

/**
 * Constructs a two column starting from the left as such:
 *
 * ------------
 * | 1     2  |
 * |          |
 * |       3  |
 * ------------
 *
 * If 1 is missing:
 * ------------
 * | 2     3  |
 * |          |
 * |          |
 * ------------
 *
 */
export class OneToManyTwoColumnLeft extends TwoColumn {
  public constructor(column: Column) {
    super(column) /* istanbul ignore next */;
    this.setLeftAndRightColumn(
      [this.wrappedColumn.modules[0]],
      this.wrappedColumn.modules.splice(1)
    );
  }
}
